import { JSX, ReactNode } from 'react'

import { PrimaryButton, SecondaryButton } from '../actions/special/DynamicWidthButtons'
import { ResponsiveButtonContainer } from '../global/CommonStyling'
import { BaseModal } from './BaseModal'
import { ModalContent } from './ModalContent'
import { ModalVisualMode } from './ModalTypes'
import { getIcon } from './ModalUtils'

export type ButtonType = 'primary' | 'secondary'

export interface AlertModalProps {
  header?: string
  contentLabel?: string
  children?: ReactNode
  buttonLabel: string
  buttonType?: ButtonType
  isOpen: boolean
  mode?: ModalVisualMode
  onButtonClick: () => unknown
  requestId?: string
}

export const AlertModal = ({
  contentLabel,
  children,
  onButtonClick,
  buttonLabel,
  buttonType = 'primary',
  isOpen,
  header,
  mode = ModalVisualMode.Plain,
  requestId,
}: AlertModalProps): JSX.Element => {
  const icon = getIcon(mode)
  const isPrimaryButton = buttonType === 'primary'
  const buttons = (
    <ResponsiveButtonContainer $hasMarginTop={true}>
      {isPrimaryButton ? (
        <PrimaryButton data-testid="alert-modal-button" onClick={onButtonClick} label={buttonLabel} />
      ) : (
        <SecondaryButton data-testid="alert-modal-button" onClick={onButtonClick} label={buttonLabel} />
      )}
    </ResponsiveButtonContainer>
  )
  return (
    <BaseModal
      contentLabel={contentLabel ?? header ?? 'Alert modal'}
      onClose={onButtonClick}
      isOpen={isOpen}
      footer={buttons}
    >
      <ModalContent icon={icon} header={header} requestId={requestId}>
        {children}
      </ModalContent>
    </BaseModal>
  )
}
